import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { TasksStatusCardBase } from '@fi-shared/fi-task-shared/tasks-status/common-code/tasks-status-card-base';

@Component({
    selector: 'fi-tasks-status-archived',
    template: `
        <mat-card>
            <mat-card-header class="fi-tasks-status-card-header">
                {{ 'task.status_archived_header' | fiAppText }}
            </mat-card-header>
            <mat-card-content>
                <button
                    mat-flat-button
                    [disabled]="isActionDisabled()"
                    color="primary"
                    class="fi-tasks-status-action-button"
                    [matMenuTriggerFor]="taskActionMenu"
                >
                    {{ 'common.with_selected' | fiAppText }}
                    <mat-icon class="fas fa-chevron-down" inline></mat-icon>
                </button>

                <fi-wrapper-table
                    [items]="tasks"
                    [hasCheckedColumn]="true"
                    matSort
                    #sort="matSort"
                    [sort]="sort"
                    [checkedItems]="selectedTasks"
                    (checkedItemsChange)="selectedTasks = $event"
                >
                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                            'task.task' | fiAppText
                        }}</mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ item.Name }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="IsCompleted">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                            'common.status' | fiAppText
                        }}</mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ getCompletedText(item) }} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ArchivedOn">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
                            'task.archived_on' | fiAppText
                        }}</mat-header-cell>
                        <mat-cell *matCellDef="let item"> {{ item.ArchivedOn | fiFormatDate: 'date' }} </mat-cell>
                    </ng-container>
                </fi-wrapper-table>
            </mat-card-content>
        </mat-card>
        <mat-menu #taskActionMenu>
            @for (action of taskActionItems; track action) {
                <button
                    mat-menu-item
                    (click)="action.onClick()"
                    [disabled]="isActionDisabled()"
                    [attr.aria-label]="action.title"
                >
                    <span>{{ action.title }}</span>
                </button>
            }
        </mat-menu>
    `,
    styleUrls: ['./tasks-status-archived.component.scss', '../common-code/tasks-status-card-base.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-tasks-status-archived' },
    standalone: false,
})
export class TasksStatusArchivedComponent extends TasksStatusCardBase implements OnInit {
    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.taskActionItems = [
            {
                title: this.appTextService.get('task.restore_tasks'),
                onClick: () => super.saveTaskArchived(false),
            },
            {
                title: this.appTextService.get('common.delete_permanently'),
                onClick: () => super.deleteTasks(),
            },
        ];
    }

    getCompletedText(item: ITask) {
        return this.appTextService.get(item.IsCompleted ? 'common.completed' : 'common.uncompleted');
    }
}
